import { Admin as AdminTypes } from '../../types'

const {
  ADMIN_REQUEST_FETCH_SUPPORTS,
  ADMIN_REQUEST_CREATE_SUPPORT,
  ADMIN_REQUEST_UPDATE_SUPPORT,
  ADMIN_REQUEST_DELETE_SUPPORT,
  ADMIN_ACTION_SUPPORT_SUCCESS,
  ADMIN_ACTION_SUPPORT_ERROR,
  ADMIN_RESET_SUPPORT
} = AdminTypes.support

const initialState = {
  supports: [],
  isLoading: false,
  errors: {
    status: false,
    message: null
  }
}

export default (state = initialState, action) => {
  switch (action.type) {

    case ADMIN_ACTION_SUPPORT_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          status: true,
          message: action.payload.message
        }
      }

    case ADMIN_ACTION_SUPPORT_SUCCESS:
      return {
        ...state,
        supports: action.payload.supports,
        isLoading: false,
        errors: {
          ...state.errors,
          status: false,
          message: null
        }
      }

    case ADMIN_REQUEST_FETCH_SUPPORTS:
    case ADMIN_REQUEST_CREATE_SUPPORT:
    case ADMIN_REQUEST_UPDATE_SUPPORT:
    case ADMIN_REQUEST_DELETE_SUPPORT:
      return {
        ...state,
        isLoading: true,
        errors: {
          ...state.errors,
          status: false,
          message: null
        }
      }

    case ADMIN_RESET_SUPPORT:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          status: false,
          message: null
        }
      }

    default:
      return state

  }
}
